<template>
  <div class="view-wrap">
    <div class="menu">
      <div class="menu-left">
        <div class="item">
          <i class="iconfont el-icon-arrow-left"></i>
          <i class="iconfont icondian1"></i>
          <i class="iconfont icondian1"></i>
        </div>
        <div
          class="item process"
          v-for="(item, index) in menu"
          :key="index"
          @click="changeStep(index)"
        >
          <span :class="{ active: step === index }">
            {{ item.name }}
          </span>
        </div>
        <div class="item">
          <i class="iconfont el-icon-arrow-right"></i>
        </div>
      </div>
      <div
        class="menu-left"
        style="color:#ffffff;cursor: pointer;"
        @click="drawer = true"
      >
        数据库
      </div>
    </div>
    <div style="height: calc(100% - 80px);overflow-y: auto;">
      <el-row>
        <el-col v-if="step === 0">
          <SelectTpl @changeStep="changeStep"></SelectTpl>
        </el-col>
        <el-col v-if="step === 1">
          <BaseEdit @changeStep="changeStep"></BaseEdit>
        </el-col>
        <el-col v-if="step === 2">
          <ImageEdit @changeStep="changeStep"></ImageEdit>
        </el-col>
        <el-col v-if="step === 3">
          <PriceEdit @changeStep="changeStep"></PriceEdit>
        </el-col>
        <el-col v-if="step === 4">
          <LogisticsEdit @changeStep="changeStep"></LogisticsEdit>
        </el-col>
      </el-row>
    </div>
    <el-drawer
      size="80%"
      title="我是标题"
      :with-header="false"
      :visible.sync="drawer"
    >
      <ProductsView></ProductsView>
    </el-drawer>
  </div>
</template>
<script>
import SelectTpl from "./components/selectTpl.vue";
import BaseEdit from "./components/baseEdit.vue";
import ImageEdit from "./components/imgEdit.vue";
import PriceEdit from "./components/priceEdit.vue";
import LogisticsEdit from "./components/logisticsEdit.vue";
import { templateData, menuList } from "./data";
import ProductsView from "./products.vue";
export default {
  data() {
    return {
      productList: templateData,
      menu: menuList,
      step: 0,
      drawer: false,
    };
  },
  components: {
    SelectTpl,
    BaseEdit,
    ImageEdit,
    PriceEdit,
    LogisticsEdit,
    ProductsView,
  },
  methods: {
    changeStep(step) {
      this.step = step;
    },
  },
};
</script>
<style scoped lang="scss">
.view-wrap {
  width: 100%;
  height: 100%;
}
.menu {
  margin-bottom: 26px;
  display: flex;
  justify-content: space-between;

  div.menu-left {
    height: 60px;
    font-size: 14px;
    background: #4149a9;
    box-shadow: 0px 20px 30px -16px #b7ccce;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 26px;

    > .item {
      display: flex;
      align-items: center;
      color: black;
      cursor: pointer;

      &.process span {
        color: #ffffff;
        &.active {
          color: #ff65a5;
        }

        margin: 0 8px;
      }

      > i {
        color: #ffffff;
        font-size: 12px;
        font-weight: bolder;
        margin: 0 2px;
      }
    }
  }

  div.menu-right {
    height: 60px;
    background: #079bab;
    box-shadow: 0px 20px 30px -16px #b7ccce;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 28px;
    color: #ffffff;
    font-size: 16px;
    padding: 0 20px;

    > .manage {
      display: flex;
      align-items: center;

      i {
        margin: 0 10px 0 6px;
        font-size: 20px;
      }

      > span {
        width: 0;
        height: 16px;
        border-left: 2px solid #ffffff;
        margin: 0 14px;
      }
    }

    > .item {
      span {
        cursor: pointer;
        padding: 9px 22px;
        cursor: pointer;
        color: #ffffff;

        &.active,
        &:hover {
          background: #ffffff;
          border-radius: 10px;
          color: #079bab;
        }
      }
    }
  }
}
</style>
